/**
 * 饲养员名号体系
 * 根据单局总分授予对应段位名号
 */
export const TITLES = [
    { name: '实习饲养员', icon: '🍼', min: 0, max: 79, quote: '娃一哭就喊妈，说的就是你。' },
    { name: '青铜饲养员', icon: '🧸', min: 80, max: 159, quote: '至少分清尿不湿正反面了。' },
    { name: '白银饲养员', icon: '🛁', min: 160, max: 219, quote: '能独立给娃洗澡，但最好有人看着。' },
    { name: '黄金饲养员', icon: '🥇', min: 220, max: 279, quote: '冲奶水温控制精准，已超越60%的人类。' },
    { name: '铂金饲养员', icon: '👑', min: 280, max: 339, quote: '哄睡技巧直逼月嫂，全家表示满意。' },
    { name: '钻石饲养员', icon: '💎', min: 340, max: 369, quote: '处理红屁股手法行云流水，儿科护士点赞。' },
    { name: '王者饲养员', icon: '🚀', min: 370, max: 399, quote: '你就是行走的育儿百科，小区遛娃界天花版。' },
    { name: '神兽饲养员', icon: '🏆', min: 400, max: 400, quote: '建议直接开育儿专栏，传奇饲养员本员！' },
];
/**
 * 根据分数获取对应名号
 */
export function getTitleForScore(score) {
    for (const t of TITLES) {
        if (score >= t.min && score <= t.max)
            return t;
    }
    return TITLES[TITLES.length - 1];
}
//# sourceMappingURL=titles.js.map